import { render, staticRenderFns } from "./SharerRateTierCard.vue?vue&type=template&id=18331a2e&scoped=true"
import script from "./SharerRateTierCard.vue?vue&type=script&lang=js"
export * from "./SharerRateTierCard.vue?vue&type=script&lang=js"
import style0 from "./SharerRateTierCard.vue?vue&type=style&index=0&id=18331a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18331a2e",
  null
  
)

export default component.exports